import React from "react";
import { useTheme } from "../../../contexts/ThemeContext";
import { ChartColumn, Table } from "lucide-react";
import MapTooltip from "../MapTooltip";

interface MapViewsMenuProps {
    viewCharts: boolean;
    viewTable: boolean;
    onViewChartsChange: (value: boolean) => void;
    onViewTableChange: (value: boolean) => void;
    className?: string;
}

const MapViewsMenu: React.FC<MapViewsMenuProps> = ({
    viewCharts,
    viewTable,
    onViewChartsChange,
    onViewTableChange,
}) => {
    const { theme } = useTheme();

    return (
        <div className="flex flex-col">
            <MapTooltip
                button={
                    <button
                        className={`${
                            viewCharts
                                ? "bg-[#C6D92D]"
                                : "bg-white dark:bg-[#2D3748] hover:bg-[#C6C5C5] dark:hover:bg-[#4A5568] duration-200"
                        } w-[24px] h-[24px] flex items-center justify-center cursor-pointer focus:ring-none rounded-t-[4px]`}
                        onClick={() => onViewChartsChange(!viewCharts)}
                    >
                        <ChartColumn
                            size={14}
                            className={`${
                                viewCharts
                                    ? "stroke-[#2D3748]"
                                    : theme === "light"
                                      ? "stroke-[#535353]"
                                      : "stroke-[#7A8690]"
                            }`}
                        />
                    </button>
                }
                text="View charts"
            />
            <MapTooltip
                button={
                    <button
                        className={`${
                            viewTable
                                ? "bg-[#C6D92D]"
                                : "bg-white dark:bg-[#2D3748] hover:bg-[#C6C5C5] dark:hover:bg-[#4A5568] duration-200"
                        } w-[24px] h-[24px] flex items-center justify-center cursor-pointer focus:ring-none duration-200 rounded-b-[4px]`}
                        onClick={() => onViewTableChange(!viewTable)}
                    >
                        <Table
                            size={14}
                            className={`${
                                viewTable
                                    ? "stroke-[#2D3748]"
                                    : theme === "light"
                                      ? "stroke-[#535353]"
                                      : "stroke-[#7A8690]"
                            }`}
                        />
                    </button>
                }
                text="View table"
            />
        </div>
    );
};

export default MapViewsMenu;

